import { graphLightRed, graphPictonBlue, graphSandyBrown, graphTropicalIndigo } from '../../../styles/design-tokens';

const MAX_SELECTION = 4;
const EPIC_SEARCH_THRESHOLD = 10;

const CHART_COLORS = [graphTropicalIndigo, graphLightRed, graphPictonBlue, graphSandyBrown];

export { CHART_COLORS, EPIC_SEARCH_THRESHOLD, MAX_SELECTION };
